import { admin, palette, radii, typography } from '../../../styles/tokens';

interface ProgressIndicatorProps {
  completedCount: number;
  totalCount: number;
  minutesRemaining: number;
}

export default function ProgressIndicator({
  completedCount,
  totalCount,
  minutesRemaining,
}: ProgressIndicatorProps) {
  if (completedCount === 0) {
    return (
      <div style={{ marginBottom: 32 }}>
        <span
          style={{
            display: 'inline-block',
            padding: '6px 12px',
            borderRadius: radii.full,
            background: palette.g100,
            color: admin.caption,
            fontSize: typography.size.caption,
            fontWeight: typography.weight.medium,
            letterSpacing: '-0.005em',
          }}
        >
          Getting started
        </span>
      </div>
    );
  }

  const pct = totalCount > 0 ? (completedCount / totalCount) * 100 : 0;

  return (
    <div style={{ marginBottom: 32, maxWidth: 480 }}>
      <div
        style={{
          height: 6,
          borderRadius: radii.full,
          background: palette.g150,
          overflow: 'hidden',
          marginBottom: 10,
        }}
      >
        <div
          style={{
            width: `${pct}%`,
            height: '100%',
            background: palette.accent,
            borderRadius: radii.full,
            transition: 'width 300ms ease',
          }}
        />
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 16,
        }}
      >
        <span
          style={{
            fontSize: typography.size.caption,
            fontWeight: typography.weight.semibold,
            color: admin.header,
          }}
        >
          {completedCount} of {totalCount} done
        </span>
        <span
          style={{
            fontSize: typography.size.caption,
            color: admin.caption,
          }}
        >
          About {minutesRemaining} more minutes.
        </span>
      </div>
    </div>
  );
}
